function CheckIcon({ ...rest }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='28'
      height='29'
      viewBox='0 0 28 29'
      fill='none'
      {...rest}
    >
      <path
        d='M11.8565 16.9276L19.2721 9.48474C19.4471 9.3091 19.6549 9.22128 19.8956 9.22128C20.1362 9.22128 20.344 9.3091 20.519 9.48474C20.694 9.66038 20.7815 9.86896 20.7815 10.1105C20.7815 10.352 20.694 10.5606 20.519 10.7362L12.469 18.8158C12.294 18.9914 12.0898 19.0793 11.8565 19.0793C11.6232 19.0793 11.419 18.9914 11.244 18.8158L7.48149 15.0395C7.30649 14.8638 7.22264 14.6552 7.22993 14.4137C7.23722 14.1722 7.32837 13.9636 7.50337 13.788C7.67837 13.6124 7.88618 13.5245 8.1268 13.5245C8.36743 13.5245 8.57524 13.6124 8.75024 13.788L11.8565 16.9276Z'
        fill='currentColor'
      />
    </svg>
  );
}

export default CheckIcon;
